// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FilePrecheckController from "./file_precheck_controller"
application.register("file-precheck", FilePrecheckController)

import DeepLinkController from "./deep_link_controller"
application.register("deep-link", DeepLinkController)

import LocaleSwitcherController from "./locale_switcher_controller"
application.register("locale-switcher", LocaleSwitcherController)

import UppyUploadController from "./uppy_upload_controller"
application.register("uppy-upload", UppyUploadController)

import ConsentController from "./consent_controller"
application.register("consent", ConsentController)

import DeviceTabsController from "./device_tabs_controller"
application.register("device-tabs", DeviceTabsController)
